import React from "react";

export default function Navbar() {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <nav className="sticky top-0 h-fit bg-white z-50 layout shadow-md">
      <div className="flex gap-4 sm:gap-0 sm:justify-between relative">
        <button className="sm:hidden ml-4">
          <svg
            aria-hidden="true"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            className="w-8 h-8"
            onClick={() => setIsOpen((prev) => !prev)}
          >
            <path d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" strokeLinecap="round" strokeLinejoin="round"></path>
          </svg>
        </button>
        <a href="#home">
          <img src="images/best_logo.png" className="w-[200px]" alt="Logo" />
        </a>
        {/* Mobile Links */}
        <ul
          className={`p-2 rounded-md sm:hidden bg-white absolute left-4 duration-500 top-28 ${
            isOpen ? "left-0" : "-left-44"
          }`}
        >
          <li className="min-w-[10rem] text-lg hover:bg-slate-300 duration-500 p-1 rounded-md text-blue-900">
            <a className="w-full block" href="#service">
              Service
            </a>{" "}
          </li>
          <li className="min-w-[10rem] text-lg hover:bg-slate-300 duration-500 p-1 rounded-md text-blue-900">
            <a className="w-full block" href="#about-us">
              About Us
            </a>{" "}
          </li>
          <li className="min-w-[10rem] text-lg hover:bg-slate-300 duration-500 p-1 rounded-md text-blue-900">
            <a className="w-full block" href="#contact-us">
              Contact Us
            </a>{" "}
          </li>
        </ul>

        {/* Desktop Links */}
        <ul className="hidden sm:flex text-lg text-[#114f94] gap-24 items-center justify-center w-full">
          <li>
            <a href="#about-us" className="hover:bg-[#C6E2FF] duration-300 relative rounded-md">About Us</a>{" "}
          </li>
          <li>
            <a href="#service" className="hover:bg-[#C6E2FF] duration-300 relative rounded-md">Service</a>{" "}
          </li>
          <li>
            <a href="#contact-us" className="hover:bg-[#C6E2FF] duration-300 relative rounded-md">Contact Us</a>{" "}
          </li>
        </ul>
      </div>
    </nav>
  );
}
